import { axios } from "utils";

import { COUNTRY_CODE, GLOBAL_GENERAL_URL as endpoint } from "consts";

import { ModuleCalculator, PointPrices, Referrals, RegionApiResponse, RegionResponse } from "models";

// TODO: data does not yet have correct types

export const getSearchSuggestions = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/search-suggestions`, { data });

export const getTags = async (data: { language: string; signal: AbortSignal }) => axios.get(`${endpoint}/tags/${data.language ?? ""}`, { data });

// needed for admin

export const getMethodNames = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/methods`, { data });

export const getModuleNames = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/modules`, { data });

export const getApplications = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/applications`, { data });

export const getCurrentPrice = async (data: { farmId?: string; signal: AbortSignal }): Promise<PointPrices & { maxHectares: number }> =>
  axios.get(`${endpoint}/carbon-price`, { data });

export const getReferrer = async (data: { referralToken: string; signal: AbortSignal }) =>
  axios.get(`${endpoint}/referral-codes/${data.referralToken}`, { data });

export const getReferralValues = async (data: { signal: AbortSignal }): Promise<Referrals> => axios.get(`${endpoint}/referral-values`, { data });

export const getVideoDetails = async (data: { vimeoId: string; signal: AbortSignal }) => axios.get(`${endpoint}/video-details/${data.vimeoId}`, { data });

export const getModuleCalculatorDetails = async (data: { signal: AbortSignal }): Promise<ModuleCalculator> =>
  axios.get(`${endpoint}/module-calculator-details`, { signal: data.signal });

export const getTermsDeadlineDates = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/terms-deadline-dates`, { data });

export const getCountryRegions = async (data: { signal: AbortSignal; countryCode: COUNTRY_CODE }): Promise<RegionResponse> =>
  axios.get(`${endpoint}/regions`, { data });

export const getCountryRegionNames = async (data: { signal: AbortSignal; countryCode: COUNTRY_CODE }): Promise<RegionApiResponse> =>
  axios.get(`${endpoint}/region-names`, { data });

export const getYearlyDataYear = async (data: { farmId?: string }): Promise<number> => axios.get(`${endpoint}/yearly-data-year`, { data });
